import * as Actions from '../actions';
// import _ from '@lodash';

const initialState = {
    kuesioner : {
        rows:[],
        total:0,
        dirty: 1
    },
    fetch_kuesioner : {
        rows: [],
        total: 0
    },
    rekap_kemajuan: {
        rows: [],
        total: 0
    },
    rincian_rekap_kemajuan: {
        rows: [],
        total: 0
    },
    peringkat_pengisian: {
        rows: [],
        total: 0
    },
    kemajuan_total: {
        rows: [],
        total: 0
    },
    plain_kuesioner: [],
    konfirmasi_instrumen_id: null,
    konfirmasi_instrumen: null,
    hasil_rekap: {},
    hasil_konfirmasi: {},
    checkSelect : {},
    checkRadio: {},
    dirty: 0,
    hasil_catat_timeline: [],
    instrumen_total: {
        total: 0,
        rows: []
    },
    cek_jawaban_utama_semua: {
        rows: [],
        total: 0
    }
};

const instrumenReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_KUESIONER:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                fetch_kuesioner: action.payload
                // kuesioner: kuesioner
            };
        }
        case Actions.GET_PLAIN_KUESIONER:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                plain_kuesioner: action.payload
                // kuesioner: kuesioner
            };
        }
        case Actions.SET_KUESIONER:
        {
            // console.log(action.payload.rows[0].bentuk_pendidikan_id);
            // console.log(action.kuesioner);

            let check = [];
            let radioCheck = [];

            for (let index = 0; index < action.kuesioner.rows.length; index++) {
                const element = action.kuesioner.rows[index];
                check[element.instrumen_id] = true;

                if(element.tipe_instrumen_id === 3 && element.nilai === 1){
                    radioCheck[element.ins_instrumen_id] = element.instrumen_id;
                }
            }

            // console.log(radioCheck);

            return {
                ...state,
                kuesioner: action.kuesioner,
                checkSelect: check,
                checkRadio: radioCheck
            };
        }
        
        case Actions.SET_KUESIONER_DIRTY:
        {
            return {
                ...state,
                dirty: action.dirty
            };
        }
        
        case Actions.SET_RADIO_KUESIONER:
        {
            // console.log(action.radioCheck);
            let radioCheck = [];

            for (let index = 0; index < action.radioCheck.rows.length; index++) {
                const element = action.radioCheck.rows[index];

                if(element.tipe_instrumen_id === 3 && element.nilai === 1){
                    radioCheck[element.ins_instrumen_id] = element.instrumen_id;
                }
                
            }

            // console.log(radioCheck);

            return {
                ...state,
                radioCheck: radioCheck
            };
        }

        case Actions.GET_REKAP_KEMAJUAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                rekap_kemajuan: action.payload
            };
        }
        
        case Actions.GET_RINCIAN_REKAP_KEMAJUAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                rincian_rekap_kemajuan: action.payload
            };
        }
        
        case Actions.HITUNG_REKAP_KEMAJUAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                rekap_kemajuan: action.payload
                // hasil_rekap: action.payload
            };
        }

        case Actions.SET_KONFIRMASI_SELESAI:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_konfirmasi: action.payload
            };
        }
        
        case Actions.GET_KONFIRMASI_SELESAI:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                konfirmasi_instrumen: action.payload
            };
        }
        
        case Actions.SET_KUNCI_KONFIRMASI_INSTRUMEN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                konfirmasi_instrumen_id: action.konfirmasi_instrumen_id
            };
        }
        
        case Actions.GET_PERINGKAT_PENGISIAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                peringkat_pengisian: action.payload
            };
        }
        
        case Actions.GET_KEMAJUAN_TOTAL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                kemajuan_total: action.payload
            };
        }

        case Actions.CATAT_TIMELINE:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_catat_timeline: action.payload
            };
        }

        case Actions.INSTRUMEN_TOTAL:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                instrumen_total: action.payload
            };
        }

        case Actions.CEK_JAWABAN_UTAMA_SEMUA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                cek_jawaban_utama_semua: action.payload
            };
        }

        default:
        {
            return state;
        }
    }
}

export default instrumenReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/Instrumen.reducers.js